/* router.js */
 
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router) // 注册路由

import Index from '../views/index.vue' 						// 首页
import productService from '../views/productService.vue'	// 产品与服务 
import aboutUS from '../views/aboutUS.vue' 					// 关于我们
import login from '../views/login.vue' 						// 登录
import register from '../views/register.vue' 				// 注册
import passwordRetrieval from '../views/passwordRetrieval.vue' 				// 找密码
import personCenter from '../views/personCenter.vue' 		// 个人中心
import serviceAgreement from '../views/serviceAgreement.vue'// 服务协议
import privacyAgreement from '../views/privacyAgreement.vue'// 隐私协议
import mOrderRecord from '../views/mOrderRecord.vue'// 订单记录详情
 
export default new Router({
	mode: 'history',
    routes: [
	    {
	        path: '/',
	        component: Index,
			redirect: '/index'
	    },
		{
	        path: '/index',
	        name: 'index',
	        component: Index
	    },
	    {
	        path: '/productservice',
	        name: 'productService',
	        component: productService
	    },
	    {
	        path: '/contactus',
	        name: 'aboutUS',
	        component: aboutUS
	    },
		{
	        path: '/login',
	        name: 'login',
	        component: login
	    },
		{
	        path: '/register',
	        name: 'register',
	        component: register
	    },
		{
	        path: '/passwordRetrieval',
	        name: 'passwordRetrieval',
	        component: passwordRetrieval
	    },
		{
	        path: '/personCenter',
	        name: 'personCenter',
	        component: personCenter
	    },
		{
	        path: '/mOrderRecord',
	        name: 'mOrderRecord',
	        component: mOrderRecord
	    },
		{
	        path: '/serviceAgreement',
	        name: 'serviceAgreement',
	        component: serviceAgreement
	    },
		{
	        path: '/privacyAgreement',
	        name: 'privacyAgreement',
	        component: privacyAgreement
	    },
    ]
})